<template>
  <div>
    <b-card
      no-body
      class="mb-1"
    >
      <div
        class="p-1 d-flex flex-wrap align-items-end"
        style="gap: 10px"
      >
        <div style="min-width: 200px">
          <label
            class="d-block mb-25"
            style="font-size: 12px"
          >Tipo</label>
          <v-select
            v-model="filtroTipo"
            :options="tipos"
            :reduce="t => t.id"
            label="name"
            placeholder="Todos"
          />
        </div>
        <button
          class="btn btn-sm btn-primary"
          @click="carregar"
        >
          Buscar
        </button>
        <div class="ml-auto">
          <button
            v-if="$hasAbility('cadastro.gerenciar')"
            class="btn btn-sm btn-success"
            @click="abrirNovo"
          >
            Novo equipamento
          </button>
        </div>
      </div>
    </b-card>

    <b-card no-body>
      <div
        v-if="carregando"
        class="text-center py-4"
      >
        <b-spinner
          small
          variant="primary"
        />
      </div>

      <div
        v-else-if="itens.length === 0"
        class="text-center text-muted py-4"
      >
        Nenhum equipamento cadastrado neste nó.
      </div>

      <table
        v-else
        class="table table-sm mb-0"
      >
        <thead>
          <tr>
            <th>Equipamento</th>
            <th>Tipo</th>
            <th>Série</th>
            <th class="text-right">
              Total
            </th>
            <th class="text-right">
              Em uso
            </th>
            <th class="text-right">
              Retido
            </th>
            <th class="text-right">
              Disponível
            </th>
            <th class="text-right">
              Ações
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in itens"
            :key="item.id"
          >
            <td>
              {{ item.name }}
              <small
                v-if="item.measure_value"
                class="text-muted"
              >
                · {{ item.measure_value }} {{ item.unit }}
              </small>
            </td>
            <td>{{ item.type || '—' }}</td>
            <td>
              <span
                v-if="item.serial"
                class="badge badge-secondary text-monospace"
              >
                {{ item.serial }}
              </span>
              <span
                v-else
                class="text-muted"
              >—</span>
            </td>
            <td class="text-right num">
              {{ item.total_quantity }}
            </td>
            <td class="text-right num">
              {{ item.em_uso }}
            </td>
            <td class="text-right num">
              <span :class="item.retido ? 'text-warning' : 'text-muted'">
                {{ item.retido || 0 }}
              </span>
            </td>
            <td class="text-right num">
              <span :class="item.disponivel === 0 ? 'text-danger' : 'text-success'">
                {{ item.disponivel }}
              </span>
            </td>
            <td
              class="text-right"
              style="white-space: nowrap"
            >
              <router-link
                class="btn btn-sm btn-outline-secondary mr-25"
                title="Histórico e rastreio"
                :to="{ name: 'equipment-history', params: { id: item.id } }"
              >
                <feather-icon
                  icon="ClockIcon"
                  size="14"
                />
              </router-link>
              <button
                class="btn btn-sm btn-outline-primary mr-25"
                :disabled="item.disponivel === 0"
                :title="item.disponivel === 0 ? 'Nada disponível' : 'Alocar para uma equipe'"
                @click="abrirAlocacao(item)"
              >
                Alocar
              </button>
              <button
                v-if="$hasAbility('cadastro.gerenciar')"
                class="btn btn-sm btn-outline-secondary"
                @click="abrirEdicao(item)"
              >
                Editar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card>

    <b-modal
      v-model="mostrarForm"
      :title="form.id ? 'Editar equipamento' : 'Novo equipamento'"
      hide-footer
    >
      <div class="form-group">
        <label>Tipo</label>
        <v-select
          v-model="form.type_id"
          :options="tipos"
          :reduce="t => t.id"
          label="name"
        />
      </div>
      <div class="form-group">
        <label>Nome</label>
        <input
          v-model="form.name"
          type="text"
          class="form-control"
          maxlength="120"
        >
      </div>
      <div class="form-group">
        <label>Número de série</label>
        <input
          v-model="form.serial"
          type="text"
          class="form-control"
          maxlength="60"
        >
        <small class="text-muted">
          Preenchido, o equipamento é individual e o total é 1.
        </small>
      </div>
      <div class="row">
        <div class="form-group col-4">
          <label>Medida</label>
          <input
            v-model.number="form.measure_value"
            type="number"
            step="0.001"
            class="form-control"
            placeholder="500"
          >
        </div>
        <div class="form-group col-4">
          <label>Unidade</label>
          <v-select
            v-model="form.unit_id"
            :options="unidades"
            :reduce="(u) => u.id"
            label="name"
            placeholder="ml"
          />
        </div>
        <div class="form-group col-4">
          <label>Quantidade</label>
          <input
            v-model.number="form.total_quantity"
            :disabled="!!(form.serial && form.serial.trim())"
            type="number"
            min="1"
            class="form-control"
            placeholder="5"
          >
        </div>
      </div>
      <p
        class="text-muted"
        style="font-size: 12px"
      >
        {{ exemploDoItem }}
      </p>
      <div class="text-right">
        <button
          class="btn btn-secondary mr-1"
          @click="mostrarForm = false"
        >
          Cancelar
        </button>
        <button
          class="btn btn-primary"
          :disabled="salvando"
          @click="salvar"
        >
          {{ salvando ? 'Salvando...' : 'Salvar' }}
        </button>
      </div>
    </b-modal>

    <b-modal
      v-model="mostrarAlocacao"
      title="Alocar para uma equipe"
      hide-footer
    >
      <p
        v-if="itemAlocando"
        class="mb-1"
      >
        <strong>{{ itemAlocando.name }}</strong>
        — disponível: {{ itemAlocando.disponivel }}
      </p>
      <div class="form-group">
        <label>Equipe</label>
        <v-select
          v-model="alocacao.team_id"
          :options="equipes"
          :reduce="e => e.id"
          label="name"
        />
      </div>
      <div class="form-group">
        <label>Quantidade</label>
        <input
          v-model.number="alocacao.quantity"
          type="number"
          min="1"
          :max="itemAlocando ? itemAlocando.disponivel : 1"
          class="form-control"
        >
      </div>
      <div class="text-right">
        <button
          class="btn btn-secondary mr-1"
          @click="mostrarAlocacao = false"
        >
          Cancelar
        </button>
        <button
          class="btn btn-primary"
          :disabled="alocando"
          @click="alocar"
        >
          {{ alocando ? 'Alocando...' : 'Alocar' }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ApiErrorMixin from '@/mixins/ApiErrorMixin'

export default {
  name: 'EquipmentIndex',
  mixins: [ApiErrorMixin],

  props: {
    nodeId: {
      type: [Number, String],
      default: null,
    },
  },

  data() {
    return {
      itens: [],
      tipos: [],
      unidades: [],
      equipes: [],
      filtroTipo: null,
      carregando: false,
      salvando: false,
      alocando: false,
      mostrarForm: false,
      mostrarAlocacao: false,
      itemAlocando: null,
      form: this.formVazio(),
      alocacao: { team_id: null, quantity: 1 },
    }
  },

  computed: {
    paramsNo() {
      return this.nodeId ? { node_id: this.nodeId } : {}
    },

    unidadeDoTipo() {
      const t = this.tipos.find(x => x.id === this.form.type_id)
      return t && t.unit ? t.unit.abbreviation : null
    },

    exemploDoItem() {
      const q = this.form.total_quantity || 0
      const nome = this.form.name || 'item'
      const u = this.unidades.find(x => x.id === this.form.unit_id)
      const medida = this.form.measure_value && u
        ? ` de ${this.form.measure_value} ${u.abbreviation}`
        : ''

      return `Fica cadastrado como: ${q} ${nome}${medida}.`
    },
  },

  watch: {
    'form.type_id': function sugereUnidade(novo) {
      if (this.form.unit_id) return

      const t = this.tipos.find(x => x.id === novo)
      if (t && t.unit_id) this.form.unit_id = t.unit_id
    },
  },

  mounted() {
    this.carregarTipos()
    this.carregarUnidades()
    this.carregarEquipes()
    this.carregar()
  },

  methods: {
    formVazio() {
      return {
        id: null, type_id: null, unit_id: null, name: '', serial: '', measure_value: null, total_quantity: 1,
      }
    },

    async carregar() {
      this.carregando = true
      try {
        const params = { ...this.paramsNo }
        if (this.filtroTipo) params.type_id = this.filtroTipo

        const res = await this.$http.get(`${this.$store.state.api}equipment`, { params })
        this.itens = res.data.data || []
      } catch (e) {
        this.itens = []
        this.$message('Erro', this.apiErrorText(e, 'Não foi possível carregar os equipamentos.'), 'error')
      } finally {
        this.carregando = false
      }
    },

    async carregarTipos() {
      try {
        const res = await this.$http.get(`${this.$store.state.api}equipment/types`)
        this.tipos = res.data.data || []
      } catch (e) {
        this.tipos = []
      }
    },

    async carregarUnidades() {
      try {
        const res = await this.$http.get(`${this.$store.state.api}equipment/units`)
        this.unidades = res.data.data || []
      } catch (e) {
        this.unidades = []
      }
    },

    async carregarEquipes() {
      try {
        const res = await this.$http.get(`${this.$store.state.api}teams`, {
          params: { paginated: false, status: 1, ...this.paramsNo },
        })
        this.equipes = res.data.data || res.data || []
      } catch (e) {
        this.equipes = []
      }
    },

    abrirNovo() {
      this.form = this.formVazio()
      this.mostrarForm = true
    },

    abrirEdicao(item) {
      this.form = {
        id: item.id,
        type_id: item.type_id || null,
        unit_id: item.unit_id || null,
        name: item.name,
        serial: item.serial || '',
        measure_value: item.measure_value,
        total_quantity: item.total_quantity,
      }
      this.mostrarForm = true
    },

    async salvar() {
      this.salvando = true
      try {
        const url = `${this.$store.state.api}equipment${this.form.id ? `/${this.form.id}` : ''}`
        const corpo = { ...this.form }
        delete corpo.id

        Object.assign(corpo, this.paramsNo)

        if (this.form.id) await this.$http.put(url, corpo)
        else await this.$http.post(url, corpo)

        this.mostrarForm = false
        this.$message('Sucesso', 'Equipamento salvo.', 'success')
        this.carregar()
      } catch (e) {
        this.$message('Erro', this.apiErrorText(e, 'Não foi possível salvar.'), 'error')
      } finally {
        this.salvando = false
      }
    },

    abrirAlocacao(item) {
      this.itemAlocando = item
      this.alocacao = { team_id: null, quantity: 1 }
      this.mostrarAlocacao = true
    },

    async alocar() {
      this.alocando = true
      try {
        await this.$http.post(
          `${this.$store.state.api}equipment/${this.itemAlocando.id}/allocate`,
          { ...this.alocacao, ...this.paramsNo },
        )
        this.mostrarAlocacao = false
        this.$message('Sucesso', 'Equipamento alocado.', 'success')
        this.carregar()
      } catch (e) {
        this.$message('Erro', this.apiErrorText(e, 'Não foi possível alocar.'), 'error')
      } finally {
        this.alocando = false
      }
    },
  },
}
</script>

<style scoped>
.num {
  font-variant-numeric: tabular-nums;
}
</style>
